module.exports = __webpack_public_path__ + "static/media/dmsans-medium-webfont.dad9fcdd.woff2";